import { Component } from '@angular/core';
import { StateService } from '@app/core/services/state.service';

@Component({
    selector: 'tt-doc-article-edit-view',
    templateUrl: './doc-article-edit-view.component.html',
    styleUrls: ['./doc-article-edit-view.component.css'],
})
export class DocArticleEditViewComponent {
    public params: { docarticle_keyno: string };

    constructor(public state: StateService) {
        this.params = this.state.getStateParams() as { docarticle_keyno: string };
    }
}
